import { render, staticRenderFns } from "./vacation.vue?vue&type=template&id=56882b64"
import script from "./vacation.vue?vue&type=script&lang=js"
export * from "./vacation.vue?vue&type=script&lang=js"
import style0 from "./vacation.vue?vue&type=style&index=0&id=56882b64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports